import { themeObject } from '../../lib';

export interface InvalidPermissionsDialogProps {
    onClose: Function;
    open: boolean;
}

export const styles = {
    dialog: {
        '& .MuiPaper-root': {
            height: '180px',
            width: '462px',
            borderRadius: '10px',

            '#dialog-title-container': {
                minHeight: '68px',
            },
        },
        '& .MuiDialogContent-root': {
            padding: '0 34.5px',
        },
    },
    dialogContentText: {
        color: themeObject.palette.grayScale[800],
    },
};
